$img-width: 200px;
$img-height: 234px;

.wrapper {
  width: $img-width;
  height: $img-height;
}

.itemWrapper {
  position: absolute;
}

.avatarImg,
.itemImg {
  width: $img-width;
}
